/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelConveyanceCode.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/conveyance-code";

export class AutogenModelConveyanceCode<RowType extends ModelRow> extends Endpoint<RowType, RowConveyanceCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowConveyanceCode extends ModelRow<RowConveyanceCodeFields> {
	constructor(values?: Partial<RowConveyanceCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowConveyanceCodeFields {
	add_timestamp: Date;
	add_userid: string;
	company_id: string;
	edi_standard_code: string;
	field_code: string;
	field_code_desc: string;
	field_name: string;
	field_table_alias: string;
	mod_timestamp: Date;
	mod_userid: string;
}

